module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_6.700d560d.png";